import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const namespacers = {
    welcomeUser: createNamespacer("WELCOME_USER"),
}

const initialstate = { 
    email: {
        value: "",
        error: "",
        showError: "",
    },
    firstName:{
        value: "",
    },
    password: {
        value: "",
        error: "",
        showError: "",
    },
    confirmPassword: {
        value: "",
        error: "",
        showError: "",
    },
    profilePicture: {
        value: "",
        error: "",
        showError: "",
    },
    profilePictureSelected: false,
    isSuccessfullyUpdated: false,
    error: ""
}

const welcomeUserReducer = createReducer(initialstate, {
    [namespacers.welcomeUser("SET_EMAIL")]: (state, action) => {
        return {
            ...state,
            email: {
                ...state.email,
                value: action.payload.value
            },
        }
    },
    [namespacers.welcomeUser("SET_FIRST_NAME")]: (state, action) => {
        return {
            ...state,
            firstName: {
                ...state.firstName,
                value: action.payload.value
            },
        }
    },
    [namespacers.welcomeUser("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: {
                ...state.error,
                error: action.payload.value
            },
        }
    },
    [namespacers.welcomeUser("SET_NEW_PASSWORD")]: (state, action) => {
        return {
            ...state,
            password: {
                ...state.password,
                value: action.payload.value
            },
        }
    },
    [namespacers.welcomeUser("SET_CONFIRM_PASSWORD")]: (state, action) => {
        return {
            ...state,
            confirmPassword: {
                ...state.confirmPassword,
                value: action.payload.value
            },
        }
    },
    [namespacers.welcomeUser("SUCCESSFULLY_UPDATED")]: (state, action) => {
        return {
            ...state,
            isSuccessfullyUpdated: action.payload.value,
        }
    },
    [namespacers.welcomeUser("SET_PROFILE_PICTURE")]: (state, action) => {
        return {
            ...state,
            profilePicture: {
                ...state.profilePicture,
                value: action.payload.value
            },
            profilePictureSelected: true,
        }
    },
    [namespacers.welcomeUser("LOAD_DATA")]: (state, action) => {
        const responseMapping = {
            email: 'email',
            firstName: 'first_name',
        }

        // TODO: Add user type from roles api

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                return [key, {
                    ...state[key],
                    value: action.payload.value[responseKey] || ''
                }]
            })
        )
        
        let profilePicture = action.payload.value.thumb_url || "";

        return {
            ...state,
            ...loadedFields,
            profilePicture: {
                ...state.profilePicture,
                value: profilePicture,
            }
        }
    },
    [namespacers.welcomeUser("CLEAR_FORM")]: (state, action) => {
        return initialstate;
    },
    [namespacers.welcomeUser("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },

})

export default welcomeUserReducer;